<span class="label" id="processo-avaliativo">{{ label }}</span>
<p-select
	ariaLabelledBy="processo-avaliativo"
	[formControl]="control"
	[options]="(options$ | async) || []"
	[attr.data-cy]="dataCy"
	[showClear]="true"
	[filter]="true"
	filterBy="id,descricao,finalidade"
	[placeholder]="placeholder"
	(onChange)="changed.emit($event.value)"
	(onClear)="changed.emit(undefined)"
	emptyMessage="Nenhum processo avaliativo encontrado"
	emptyFilterMessage="Nenhum processo avaliativo encontrado"
>
	<ng-template #selectedItem>
		@if (control.value; as processoAvaliativo) {
		<span>{{processoAvaliativo.id}}&nbsp;-&nbsp;</span>
		<span> {{ processoAvaliativo.descricao | titlecase }} </span>
		@if (showFinalidade) { <span>&nbsp;-&nbsp;{{ processoAvaliativo.finalidade | titlecase }}</span>
		} }
	</ng-template>
	<ng-template let-processoAvaliativo #item>
		<div class="processo-avaliativo-item">
			<span>{{processoAvaliativo.id}}</span> - <span>{{processoAvaliativo.descricao | titlecase}}</span> @if (showFinalidade) { -
			<span>{{processoAvaliativo.finalidade | titlecase}}</span>
			}
		</div>
	</ng-template>
</p-select>
<sgp-message-feedback mensagem="O campo é obrigatório" data-cy="erro-processo-avaliativo-obrigatorio" [show]="showError" />
